import { render } from "./inputmasktemplate.vue?vue&type=template&id=213b091f"
import script from "./inputmasktemplate.vue?vue&type=script&lang=js"
export * from "./inputmasktemplate.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__